/* eslint-disable no-empty-function */
/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable  prefer-rest-params */

function checkPreventDefault(): boolean {
  const NativeCustomEvent = window?.CustomEvent
  try {
    const event = new NativeCustomEvent('newCustomEvent', {
      detail: { field: 'value' }
    })
    event.preventDefault()
    if (event.defaultPrevented !== true) {
      throw new Error('Could not prevent default')
    }
    return event.type === 'newCustomEvent' && event.detail.field === 'value'
  } catch (e) {}
  return false
}

function canUseNative(): boolean {
  const NativeCustomEvent = window?.CustomEvent
  try {
    const event = new NativeCustomEvent('newCustomEvent', {
      detail: { field: 'value' }
    })
    return event.type === 'newCustomEvent' && event.detail.field === 'value'
  } catch (e) {}
  return false
}

export interface ICustomEventParams<T> {
  bubbles?: boolean
  cancelable?: boolean
  detail?: { [key: string]: T }
}

function CustomEventPolyfill() {
  if (typeof window === 'undefined') {
    return
  }
  if (canUseNative()) {
    return
  }
  // IE >= 9
  function CustomEventIE9<T>(type: string, params: ICustomEventParams<T> = {}) {
    const { bubbles = false, cancelable = false, detail = null } = params
    const event = document.createEvent('CustomEvent')
    event.initCustomEvent(type, bubbles, cancelable, detail)
    return event
  }

  // IE <= 8
  function CustomEventIE8<T>(type: string, params: ICustomEventParams<T> = {}) {
    const { createEventObject } = (document || {}) as any
    const event = (createEventObject && createEventObject()) || {}
    const { bubbles = false, cancelable = false, detail = null } = params
    return {
      ...event,
      type,
      bubbles,
      cancelable,
      detail
    }
  }
  const hasCreateEvent = typeof document?.createEvent === 'function'
  const CustomEvent: any = hasCreateEvent ? CustomEventIE9 : CustomEventIE8

  CustomEvent.prototype = window?.Event?.prototype as any
  window.CustomEvent = CustomEvent
}

function CustomEventPreventDefaultPolyfill() {
  if (!checkPreventDefault()) {
    const preventDefault = window.CustomEvent.prototype.preventDefault
    window.CustomEvent.prototype.preventDefault = function () {
      preventDefault.apply(this, arguments as any)
      try {
        Object.defineProperty(this, 'defaultPrevented', {
          get: () => true
        })
      } catch (e) {
        this.defaultPrevented = true
      }
    }
  }
}

export function init() {
  CustomEventPolyfill()
  CustomEventPreventDefaultPolyfill()
}

init()

interface EventListener<T> {
  (evt: CustomEvent<T> | (Event & { detail?: T })): void
}

const TARGET = document
const EVENTS: { [key: string]: EventListener<any> } = {}

function dispatchEvent<T>(eventName: string, detail: T) {
  const event = new CustomEvent(eventName, { detail })

  TARGET.dispatchEvent(event)
}

export default {
  CustomEvent,
  events: EVENTS,
  on: <T>(eventName: string, callback: EventListener<T>) => {
    EVENTS[eventName] = callback
    TARGET.addEventListener(eventName, callback)
  },
  off: <T>(eventName: string) => {
    TARGET.removeEventListener(eventName, EVENTS[eventName])
    delete EVENTS[eventName]
  },
  dispatch: <T>(eventName: string, detail: T = null) => {
    dispatchEvent(eventName, detail || null)
  }
}
